import React from 'react';
import Dropdown from '../../../../components/Dropdown';
import PhoneNumber from '../../../../components/PhoneNumber';
import HtmlDate from '../../../../components/HtmlDate';
import { handleDatePicker } from '../../../../Functions/apis';
import GoBackButton from '../../../../components/GoBackButton';

function Companyprofile(props) {

	const {
		input,
		handleInput,
		handleSubmit,
		simpleValidator
	} = props.data;

	var dateObj = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
	var d = handleDatePicker(dateObj)

	return (
		<div className="job-bx submit-resume">
			<div className="job-bx-title clearfix">
				<h5 className="font-weight-700 pull-left text-uppercase">Company Profile</h5>
				<GoBackButton />
			</div>
			<div className="row m-b30">
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>First Name<span className="text-danger font-weight-bold">*</span></label>
						<input type="text" value={input?.first_name || ""} name="first_name" onChange={(e) => handleInput(e)} className="form-control" placeholder="Enter First Name" />
						<span className="text-danger">
							{simpleValidator.current.message("first name", input.first_name, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Last Name <span className="text-danger font-weight-bold">*</span></label>
						<input type="url" value={input.last_name || ""} name="last_name" onChange={(e) => handleInput(e)} className="form-control" placeholder="Enter Last Name" />
						<span className="text-danger">
							{simpleValidator.current.message("last name", input.last_name, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Company Name <span className="text-danger font-weight-bold">*</span></label>
						<input type="url" value={input.company_name || ""} name="company_name" onChange={(e) => handleInput(e)} className="form-control" placeholder="Enter Company Name" />
						<span className="text-danger">
							{simpleValidator.current.message("name", input.company_name, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Website <span className="text-danger font-weight-bold">*</span></label>
						<input type="text" value={input.website || ""} name="website" onChange={(e) => handleInput(e)} className="form-control" placeholder="Website Link" />
						<span className="text-danger">
							{simpleValidator.current.message("website", input.website, "required|url")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<HtmlDate
							label="Founded Date"
							name="founded_date"
							value={input.founded_date}
							onChange={handleInput}
							required={true}
							maxDate={d}
							onKeyPress={(e) => e.preventDefault()}
							className="form-control"
						/>
						<span className="text-danger">
							{simpleValidator.current.message("founded date", input.founded_date, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Phone <span className="text-danger font-weight-bold">*</span></label>
						<PhoneNumber
							name='mobile'
							value={input.mobile || ''}
							onChange={handleInput}
						/>
						<span className="text-danger">
							{simpleValidator.current.message("phone", input.mobile, "required|min:6")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Country <span className="text-danger font-weight-bold">*</span></label>
						<Dropdown
							url="country/"
							name="country"
							className="form-control"
							value={input.country}
							onChange={handleInput}
						/>
						<span className="text-danger">
							{simpleValidator.current.message("country", input.country, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Region <span className="text-danger font-weight-bold">*</span></label>
						<Dropdown
							url={`state/`}
							filters={input?.country?.id && `country__in=${input?.country?.id}`}
							name="state"
							className="form-control"
							value={input.state}
							onChange={handleInput}
						/>
						<span className="text-danger">
							{simpleValidator.current.message("state", input.state, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Location <span className="text-danger font-weight-bold">*</span></label>
						<Dropdown
							url={`city/`}
							filters={input?.state?.id && `state__in=${input?.state?.id}`}
							name="city"
							className="form-control"
							value={input.city}
							onChange={handleInput}
						/>
						<span className="text-danger">
							{simpleValidator.current.message("city", input.city, "required")}
						</span>
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Zip <span className="text-danger font-weight-bold">*</span></label>
						<input
							type="number"
							value={input.zipcode || ""}
							name="zipcode"
							onChange={(e) => handleInput(e)}
							className="form-control"
							placeholder="eg. 504030"
							onKeyPress={e => e.target.value.length >= 8 && e.preventDefault()}
						/>
						<span className="text-danger">
							{simpleValidator.current.message("zipcode", input.zipcode, "required|integer")}
						</span>
					</div>
				</div>
				<div className="col-lg-12 col-md-12">
					<div className="form-group">
						<label>Description <span className="text-danger font-weight-bold">*</span></label>
						<textarea type="text" className="form-control" value={input.description || ""} name="description" onChange={(e) => handleInput(e)} />
						<span className="text-danger">
							{simpleValidator.current.message("description", input.description, "required")}
						</span>
					</div>
				</div>
			</div>
			<div className="job-bx-title clearfix">
				<h5 className="font-weight-700 pull-left text-uppercase">Social link</h5>
			</div>
			<div className="row">
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Facebook</label>
						<input type="text" value={input.facebook || ""} name="facebook" onChange={(e) => handleInput(e)} className="form-control" placeholder="https://www.facebook.com/" />
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Twitter</label>
						<input type="email" value={input.twitter || ""} name="twitter" onChange={(e) => handleInput(e)} className="form-control" placeholder="https://www.twitter.com/" />
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Google</label>
						<input type="text" value={input.google || ""} name="google" onChange={(e) => handleInput(e)} className="form-control" placeholder="https://www.google.com/" />
					</div>
				</div>
				<div className="col-lg-4 col-md-4">
					<div className="form-group">
						<label>Linkedin</label>
						<input type="email" value={input.linkedin || ""} name="linkedin" onChange={(e) => handleInput(e)} className="form-control" placeholder="https://www.linkedin.com/" />
					</div>
				</div>
			</div>
			<button type="submit" onClick={handleSubmit} className="site-button m-b30">{Object.values(input).length > 0 ? "Update" : "Save"}</button>
		</div>

	)
}
export default Companyprofile;